module.exports = __webpack_public_path__ + "media/images/new-ui-images/edit-doc-41d77a24be1f33686b5fddd54fac25cd.svg";